import React from "react";
import ContentLoader from "react-content-loader";
import { Colors } from "@jsq/ds/styles";

// statically loaded preloader
export default (
  <ContentLoader
    height={600}
    width={1140}
    speed={2}
    backgroundColor={Colors.LoaderPrimary}
    foregroundColor={Colors.LoaderSecondary}
    title="Loading interface..."
    viewBox="0 0 1140 600"
  >
    <rect x="0" y="0" rx="3" ry="3" width="1140" height="600" />
  </ContentLoader>
);
